window.subscribedWasmState = [];

exports.setSubscribedWasmState = (stateKey) => () => {
  window.subscribedWasmState.push(stateKey);
};

exports.readSubscribedWasmState = () => {
  return window.subscribedWasmState;
};
